import { Box, OutlinedInput } from '@mui/material'
import { ErrorText, FormLabel } from 'components'
import type React from 'react'
import { Controller, type Control, type FieldErrors } from 'react-hook-form'
import InputMask from 'react-input-mask'

interface TextInputMaskProps {
  fieldName: string
  fieldLabel: string
  fieldType: string
  control: Control<any>
  errors: FieldErrors<any>
  placeholder?: string
  fullWidth?: boolean
  mask?: string
}

export const TextInputMask: React.FC<TextInputMaskProps> = (
  props: TextInputMaskProps
) => {
  const inputId = `input-mask-${props.fieldName}`
  const errorId = `error-${props.fieldName}`
  const hasError = props.errors[props.fieldName] != null

  return (
    <Controller
      name={props.fieldName}
      control={props.control}
      render={({ field: { onChange, value, name } }): JSX.Element => (
        <Box mb={2} width={props.fullWidth === true ? '100%' : 'auto'}>
          <FormLabel htmlFor={inputId}>
            {props.fieldLabel.toUpperCase()}
          </FormLabel>
          <InputMask
            name={name}
            mask="(999) 999-9999"
            value={value}
            maskChar="_"
            type="text"
            onChange={onChange}
          >
            <OutlinedInput
              id={inputId}
              fullWidth
              placeholder={
                props.placeholder ??
                `Enter your ${props.fieldLabel.toLowerCase()}`
              }
              error={hasError}
              inputProps={{
                'aria-invalid': hasError,
                'aria-describedby': hasError ? errorId : undefined
              }}
              sx={{
                '& input::placeholder': {
                  color: '#737373',
                  opacity: 1
                }
              }}
            />
          </InputMask>

          {hasError && (
            <ErrorText id={errorId} role="alert">
              {String(props.errors[props.fieldName]?.message)}
            </ErrorText>
          )}
        </Box>
      )}
    />
  )
}
